import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AUTH_CONFIG, type AuthConfig } from '../../../auth';
import { CurrentUtilization, UtilizationReport } from './reports-utilization.models';

@Injectable({ providedIn: 'root' })
export class ReportsUtilizationService {
  private readonly cfg = inject<AuthConfig>(AUTH_CONFIG);
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${this.cfg.baseUrl}/api/report/utilization`;

  getCurrent(): Observable<CurrentUtilization> {
    return this.http.get<CurrentUtilization>(`${this.apiUrl}/current`);
  }

  getReport(fromDate: string, toDate: string): Observable<UtilizationReport> {
    return this.http.get<UtilizationReport>(this.apiUrl, {
      params: { fromDate, toDate },
    });
  }

  // xlsx only - the filename is deterministic from the requested range, so it is built by the caller.
  exportReport(fromDate: string, toDate: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/export`, {
      params: { fromDate, toDate },
      responseType: 'blob',
    });
  }
}
